module.exports = __webpack_public_path__ + "static/media/youtube.c81d93ea.svg";